.filter-popover {
  padding: 8px;
  width: 250px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--ion-color-light);
}

.filter-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--ion-color-dark);
  text-wrap: nowrap;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.filter-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 16px;
  width: 100%;
}

.filter-content ion-list {
  padding: 0;
  width: 100%;
}

.filter-content ion-item {
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-end: 0;
  --min-height: 40px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.filter-content ion-checkbox {
  margin-right: 12px;
}

.filter-content ion-label {
  font-size: 14px;
  color: var(--ion-color-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

/* Date filter styles */
.date-filter-content {
  padding: 8px 0;
}

.date-button-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-button-group ion-button {
  --border-radius: 6px;
  --padding-start: 12px;
  --padding-end: 12px;
  height: 40px;
  font-size: 14px;
  text-transform: none;
  --color: var(--ion-color-dark);
  --border-color: var(--ion-color-medium);
}

.date-button-group ion-button.date-selected {
 

}

.date-button-group ion-button ion-icon {
  margin-right: 8px;
  font-size: 16px;
}

.filter-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid var(--ion-color-light);
  width: 100%;
  box-sizing: border-box;
}

.filter-footer ion-button {
  margin: 0;
}

/* Range filter styles */
.range-filter-content {
    padding: 16px;
}

.range-label {
    text-align: center;
    margin-bottom: 16px;
    font-weight: 500;
    color: var(--ion-color-dark);
}

.range-filter-content ion-range {
    --bar-background: var(--ion-color-light);
    --bar-background-active: var(--ion-color-primary);
    --bar-height: 4px;
    --bar-border-radius: 2px;
    --knob-background: var(--ion-color-primary);
    --knob-size: 20px;
    --pin-background: var(--ion-color-primary);
    --pin-color: white;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .filter-header h3 {
    color: var(--ion-color-light);
  }
  
  .filter-content ion-label {
    color: var(--ion-color-light);
  }

  .range-label {
    color: var(--ion-color-light);
  }
}
